import { render } from "./DashboardCarousel.vue?vue&type=template&id=2a594379"
import script from "./DashboardCarousel.vue?vue&type=script&lang=ts"
export * from "./DashboardCarousel.vue?vue&type=script&lang=ts"
script.render = render

export default script